import RevolverWinTransitions from "./revolver-win-transitions";
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import Point from "slotworks/utils/geom/point";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";
import { sequence, parallel } from "slotworks/utils/race-utils";
import { ZoomOut, FadeOut } from "slotworks/graphics/animation/base-animations";
import soundManager from "slotworks/sound/sound-manager";
import gameState from "slotworks/model/game-state";
import Components from "slotworks/components/components";
import { StartBaseMusic } from "commands/music";

export default class EpicWinTransitions extends RevolverWinTransitions {

    public TEXT_ZOOM = 1;
    private epic: PIXI.Sprite;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.inResolve = resolve;

            RevolverWinTransitions.glitter.emit = true;
            RevolverWinTransitions.coinsLeft.emit = true;
            RevolverWinTransitions.coinsRight.emit = true;

            this.epic = Layers.CelebrationContent.getSprite("epic");
            this.titleIn(this.epic, new Point(0.5, 1)).then(() => {
                RevolverWinTransitions.gemsLeft.emit = true;
                RevolverWinTransitions.gemsRight.emit = true;
                this.endlessHover(this.epic);
                this.resolveIn();
            });
        });
    }

    public skipIn() {
        this.destroy();
        this.epic.visible = true;
        this.endlessHover(this.epic);
        soundManager.customEvent("epic_win");
        RevolverWinTransitions.winValue.visible = true;
        this.setTextSize(this.TEXT_ZOOM);
        // RevolverWinTransitions.glitter.emit = true;
        // RevolverWinTransitions.coinsLeft.emit = true;
        // RevolverWinTransitions.coinsRight.emit = true;
        // RevolverWinTransitions.gemsLeft.emit = true;
        // RevolverWinTransitions.gemsRight.emit = true;
        this.resolveIn();
    }

    public out(): Contract<void> {
        RevolverWinTransitions.removeOrientationChange();
        return parallel([
            () => this.zoomOutStacks(),
            () => sequence([
                () => Contract.wrap(() => {
                    soundManager.customEvent("plaque_transition");
                    TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                    const totalWin = gameState.getCurrentGame().totalCreditsWon;
                    Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
                    RevolverWinTransitions.glitter.emit = false;
                    RevolverWinTransitions.coinsLeft.emit = false;
                    RevolverWinTransitions.coinsRight.emit = false;
                    RevolverWinTransitions.gemsLeft.emit = false;
                    RevolverWinTransitions.gemsRight.emit = false;
                }),
                () => parallel([
                    () => ZoomOut(RevolverWinTransitions.winValue, 50),
                    () => this.titleOut(this.epic, new Point(0.5, 1), 50)
                ]),
                () => Contract.wrap(() => {
                    TweenJS.removeAll(this.epic.scale);
                    TweenJS.removeAll(this.epic);
                    TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                    this.epic.visible = false;
                    soundManager.customEvent("celebration_end");
                    // soundManager.customEvent("base_reels_background_start");
                    StartBaseMusic(true);
                }),
                () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME),
                () => Contract.getTimeoutContract(750)
            ])
        ]);
    }

    public destroy() {
        this.clearTimers();

        TweenJS.removeAll(this.epic.scale);
        TweenJS.removeAll(this.epic);

        super.destroy();
    }


}